export const searchFormState = state => state.ui.searchForm;